import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-leave-page-modal',
  templateUrl: './leave-page-modal.component.html',
})
export class LeavePageModalComponent implements OnInit {
  @Output() isLeavingPage: EventEmitter<boolean> = new EventEmitter();

  leavePageModal: ModalOptions;
  hideModal = false;


  ngOnInit(): void {
    this.leavePageModal = new ModalOptions({
      additionalClasses:
        'modal-lg modal-dialog center-on-page confirm-modal email-update edit-contact-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'leavePageModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      size: 'modal-lg',
      modalName: 'leave-Page-Modal',
    });
  }

  resetHideModal(event): void {
    if (event) {
      this.isLeavingPage.emit(false);
    }
  }
  onClickStay() {
    this.isLeavingPage.emit(false);
  }
  onClickExit() {
    this.isLeavingPage.emit(true);
  }
}
